export default __webpack_public_path__ + "static/media/71.2708a557.jpg";